import React from "react";

const VARIANTS = {
  primary: "bg-cs-primary text-white hover:bg-cs-primary-hover",
  outline:
    "bg-transparent text-cs-muted border border-cs-border hover:bg-cs-primary-soft hover:text-cs-primary",
  ghost:
    "bg-transparent text-cs-muted hover:bg-cs-primary-soft hover:text-cs-primary",
};

const CustomButton = ({
  textLoad = "Processing",
  loading = false,
  onClick,
  className = "",
  children,
  isDisabled = false,
  variant = "primary",
  ...props
}) => {
  const baseClasses = `
    inline-flex items-center justify-center
    px-4 py-2
    rounded-xl
    text-xs md:text-sm
    font-medium
    transition-all
    focus:outline-none
    focus:ring-2
    focus:ring-cs-primary/40
    focus:ring-offset-1
  `;

  const disabledClasses = `
    opacity-50 cursor-not-allowed
    hover:bg-transparent
  `;

  const finalClasses = `
    ${baseClasses}
    ${VARIANTS[variant]}
    ${isDisabled || loading ? disabledClasses : ""}
    ${className}
  `;

  if (loading) {
    return (
      <button type="button" className={finalClasses} disabled {...props}>
        <svg
          className="animate-spin h-4 w-4 mr-2"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
          />
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
          />
        </svg>
        <span>{textLoad}...</span>
      </button>
    );
  }

  return (
    <button
      type="button"
      onClick={onClick}
      className={finalClasses}
      disabled={isDisabled}
      {...props}
    >
      {children}
    </button>
  );
};

export default CustomButton;
